import { render, staticRenderFns } from "./ProceduresGrid.vue?vue&type=template&id=474a9901&scoped=true&"
import script from "./ProceduresGrid.ts?vue&type=script&lang=ts&"
export * from "./ProceduresGrid.ts?vue&type=script&lang=ts&"
import style0 from "./ProceduresGrid.scss?vue&type=style&index=0&id=474a9901&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474a9901",
  null
  
)

export default component.exports